module.exports = __webpack_public_path__ + "img/ttb.ed93c1e7.png";